var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPeopleRiskIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "currentColor",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.5382 22.4145V21.9919L19.1215 21.9215C14.1128 21.075 10.2888 16.6537 10.2888 11.296C10.2888 5.31903 15.0387 0.5 20.8944 0.5C26.7501 0.5 31.5 5.31903 31.5 11.296C31.5 16.8393 27.4024 21.3839 22.1515 22.0149L21.7112 22.0678V22.5113V28.7726V29.2726H22.2112H26.4707V31.5H2.08651V23.9314V23.4314H1.58651H0.5V17.4766C0.5 16.8571 0.998054 16.3628 1.58651 16.3628H6.34606C6.93452 16.3628 7.43257 16.8571 7.43257 17.4766V23.4314H6.34606H5.84606V23.9314V28.7726V29.2726H6.34606H19.0382H19.5382V28.7726V22.4145ZM5.84606 11.8285C5.84606 12.8998 4.99897 13.7491 3.96629 13.7491C2.9336 13.7491 2.08651 12.8998 2.08651 11.8285C2.08651 10.7573 2.9336 9.90797 3.96629 9.90797C4.99897 9.90797 5.84606 10.7573 5.84606 11.8285Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeopleRiskIcon);
export default __webpack_public_path__ + "static/media/people_risk_icon.54bc530d.svg";
export { ForwardRef as ReactComponent };